import {HTMLProps} from 'react';
import clsx from 'clsx';

type Props = HTMLProps<HTMLHeadingElement> & {
  ['data-testid']?: string;
};

const SubSectionTitle = ({className, children, ...props}: Props) => {
  return (
    <h4 className={clsx('my-4 text-xl font-semibold tracking-tight text-violet', className)} {...props}>
      {children}
    </h4>
  );
};

export default SubSectionTitle;
